export enum AccessLevel {
  PUBLIC = 'Public', // Anyone can access
  GUEST = 'Guest', // digitalPlatformGuest
  PENDING = 'Pending', // digitalPlatformPendingVerification
  CUSTOMER = 'Customer', // customerPortal
  INTERNAL = 'Internal', // ravagoGlobalGroupAdmin, ravagoSalesRepresentative, ravagoGlobalViewer, ravagoGlobalEditor
  // These will be deprecated in a different ticket.
  // They need to stay for now to support the Contentful page access level field.
  AUTHENTICATED = 'Authenticated Only',
  VERIFIED = 'Verified Only',
  CSR = 'CSR Only'
}
